function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wedding_svg__cls-1{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:inherit}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "wedding_svg__cls-1",
  d: "M.147 3.122h11.407v2.281H.147z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "wedding_svg__cls-1",
  d: "M.928 5.403h9.867v6.151H.928zM5.85 3.122S6.01.146 8.04.146c1.97 0 .926 2.976-2.19 2.976M5.85 3.122S5.69.146 3.66.146c-1.97 0-.926 2.976 2.19 2.976M5.85 11.554V3.122M5.85 3.122l1.489 1.489M5.85 3.122L4.361 4.611"
});

function SvgWedding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wedding_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3);
}

export default SvgWedding;